import { LEGAL_DOCS } from '@/constants/terms';
import { cn } from '@/lib/utils';

interface TermsContentProps {
    docType?: 'privacy' | 'legal' | 'disclaimer' | 'terms';
    variant?: 'modal' | 'public';
}

export function TermsContent({ docType = 'terms', variant = 'public' }: TermsContentProps) {
    const isModal = variant === 'modal';

    if (docType === 'terms') {
        return (
            <div className="space-y-10 pr-4">
                <TermsContent docType="privacy" variant={variant} />
                <TermsContent docType="legal" variant={variant} />
                <TermsContent docType="disclaimer" variant={variant} />
                <section>
                    <h2 className={cn(
                        "text-xl font-black mb-4 uppercase tracking-tighter",
                        isModal ? "text-white" : "text-slate-950"
                    )}>
                        Términos de Servicio Adicionales
                    </h2>
                    {LEGAL_DOCS.terms.sections.map((section: any, idx: number) => (
                        <div key={idx} className="mb-6 space-y-2">
                            <h3 className={cn(
                                "font-extrabold text-base",
                                isModal ? "text-slate-100" : "text-slate-800"
                            )}>
                                {section.title}
                            </h3>
                            <p className={cn(
                                "leading-relaxed font-bold text-sm",
                                isModal ? "text-slate-200" : "text-slate-600"
                            )}>
                                {section.content}
                            </p>
                        </div>
                    ))}
                    <div className={cn(
                        "pt-6 border-t mt-6",
                        isModal ? "border-white/10" : "border-slate-200"
                    )}>
                        <p className={cn(
                            "text-[10px] uppercase font-black tracking-widest",
                            isModal ? "text-slate-400" : "text-slate-500"
                        )}>
                            Versión {LEGAL_DOCS.terms.version} | Última actualización: {LEGAL_DOCS.terms.lastUpdated}
                        </p>
                    </div>
                </section>
            </div>
        );
    }

    const doc = LEGAL_DOCS[docType];
    const standardDoc = doc as any;

    return (
        <div className="space-y-8 pr-4">
            <div className={cn(
                "border-b-2 pb-4 mb-6",
                isModal ? "border-orange-500/50" : "border-slate-900"
            )}>
                <h2 className={cn(
                    "text-2xl font-black uppercase tracking-tight",
                    isModal ? "text-white" : "text-slate-950"
                )}>
                    {standardDoc.title}
                </h2>
                <p className={cn(
                    "text-[10px] uppercase font-black tracking-widest mt-1",
                    isModal ? "text-orange-400" : "text-slate-500"
                )}>
                    Última actualización: {standardDoc.lastUpdated}
                </p>
            </div>

            {standardDoc.content.map((section: any, idx: number) => (
                <div key={idx} className="space-y-3 mb-8">
                    <h3 className={cn(
                        "text-lg font-black uppercase tracking-wide",
                        isModal ? "text-slate-100" : "text-slate-800"
                    )}>
                        {section.title}
                    </h3>
                    <p className={cn(
                        "leading-relaxed text-[15px] font-bold",
                        isModal ? "text-slate-200" : "text-slate-700"
                    )}>
                        {section.text}
                    </p>
                </div>
            ))}

            <div className={cn(
                "rounded-2xl p-6 mt-8 border",
                isModal ? "bg-white/5 border-white/10" : "bg-slate-50 border-slate-200"
            )}>
                <p className={cn(
                    "text-sm font-black italic text-center",
                    isModal ? "text-slate-300" : "text-slate-600"
                )}>
                    Cualquier duda sobre este documento: <br />
                    <span className={cn(
                        "font-black not-italic",
                        isModal ? "text-orange-500" : "text-slate-900"
                    )}>
                        gymprosv@gmail.com
                    </span>
                </p>
            </div>
        </div>
    );
}
